export default __webpack_public_path__ + "static/media/virtualpad_pad_r.44b35a10.png";